import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../config';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FacephiService {

  url = AppConfig.url_backend;

  //======Onboarding=======
  imgFace = new BehaviorSubject('');
  imagesDoc = new BehaviorSubject('');
  isOnbarding = new BehaviorSubject(false);

  existCustomer = new BehaviorSubject('');
  //======FIN Onboarding=======

  responseDocument = new BehaviorSubject('');
  responseLife = new BehaviorSubject('');
  responseLifeLP = new BehaviorSubject('');
  
  constructor(private http: HttpClient) { }

    //======Onboarding=======
  setImgFace(response:any){
    this.imgFace.next(response)
  }

  setImagesDoc(response:any){
    this.imagesDoc.next(response)
  }

  setIsOnboarding(response:any){
    this.isOnbarding.next(response)
  }

  setExistCustomer( response:any ){
    this.existCustomer.next(response)
  }

    //======FIN Onboarding=======

  setResponseLifeLP(response:any){
      this.responseLifeLP.next(response)
  }

  setResponseLife(response:any){
    this.responseLife.next(response)
  }
  setResponseDocument(response:any){
    this.responseDocument.next(response)
  }

  getHeaders(){
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*');
    return headers;
  }

  postOCR(data: any){
    return this.http.post(`${this.url}/facePhi/OCR`, data)
  }

  postVerifyDocument(data:any){
    return this.http.post(`${this.url}/facePhi/verifyDoc`, data)
  }

  postLifeValidation(data:any){
    return this.http.post(`${this.url}/facePhi/LP`, data);
  } 

  postOnboarding(data:any){
    return this.http.post(`${this.url}/facePhi/Onboarding`,data);
  }
 
  getCountry(token:string){
    return this.http.get(`${this.url}/facePhi/Country/All?Token=${token}`);
  }

  getCustomer(data:any){
    return this.http.post(`${this.url}/facePhi/Customer/`, data);
  }

  messgeDiagnostic():object {
    return {
      "Live": "El sujeto supera la prueba de vida.",
      "NoLive": "No se pudo evaluar la prueba de vida.",
      "NoneBecauseAngleTooLarge": "No se pudo evaluar la prueba de vida porque se excedió el ángulo entre rostros permitido.",
      "NoneBecauseBadQuality": "No se pudo evaluar la prueba de vida por baja calidad de las imágenes utilizadas.",
      "NoneBecauseFaceCropped": "No se pudo evaluar la prueba de vida debido a que la imagen usada está recordada.",
      "NoneBecauseFaceNotFound": "No se pudo evaluar la prueba de vida al no detectar rostros en las imágenes utilizadas.",
      "NoneBecauseFaceTooClose": "No se pudo evaluar la prueba de vida al detectar rostros muy cercanos.",
      "NoneBecauseFaceTooCloseToBorder": "No se pudo evaluar la prueba de vida al detectar rostros muy cercanos a los bordes en las imágenes utilizadas.",
      "NoneBecauseFaceTooSmall": "No se pudo evaluar la prueba de vida al detectar rostros muy pequeños en las imágenes utilizadas.",
      "NoneBecauseImageDataError": "No se pudo evaluar la prueba de vida debido al formato de las imágenes utilizadas.",
      "NoneBecauseImagePreprocessError": "No se pudo evaluar la prueba de vida debido a un error en el procesamiento de las imágenes utilizadas.",
      "NoneBecauseInternalError": "No se pudo evaluar la prueba de vida debido a un error interno.",
      "NoneBecauseLicenseError": "No se pudo evaluar la prueba de vida debido a un error de licenciamiento.",
      "Uncertain": "La prueba de vida finaliza con resultado incierto, es decir, no es posible determinar con precisión si se trata de una persona viva.",
      "NoneBecauseTooManyFaces": "No se pudo evaluar la prueba de vida debido a que existen demasiadas personas en la escena.",
      "NoneBecauseEyesClosed": "No se pudo evaluar la prueba de vida debido a que se tomo la captura del rostro, justo cuando cerro los ojos"
  }

  }
}
